import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {Button, Card, Form, Tab, Icon} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {ZONE_FORM} from '../../../../../common/forms';
import {resources, scopes} from '../../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../../common/permissions/validations';
import {panes, PANES_INDICES} from '../../../../../common/dictionaries/zones';
import {paths} from '../../../../../common/dictionaries/urls';
import AssignedLocationsConflictModal from '../modal/assignedLocationsConflict';
import ZoneData from './zoneData';
import LocationsData from './locationsData';

class ZoneForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeTabIndex': 0,
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.changeTabIndex = this.changeTabIndex.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PickingZones, scopes.See) &&
    !hasAccessPermission(this.props.permissions, resources.PickingZones, scopes.Edit)) {
      this.props.push(paths.AccessDenied);
    }
    const {code} = this.props;
    if (code) {
      this.props.fetchZone(code);
    }
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchZone(code);
    }
  }

  changeTabIndex(event, data) {
    this.setState({'activeTabIndex': data.activeIndex});
  }

  onCancelClick() {
    this.props.goBack();
  }

  getAssignedLocationsWithConflicts() {
    const {code, allLocations, assignedLocations} = this.props;

    const locationsToCheck = _.filter(allLocations,
      (element) => _.find(assignedLocations, (currentLocation) => currentLocation === element.location)
    );

    if (code) {
      return _.filter(locationsToCheck,
        (location) => location.pickingZone && Number(location.pickingZone) !== Number(code)
      );
    }
    return _.filter(locationsToCheck, (location) => location.pickingZone);
  }

  renderFormTitle() {
    const {code, name} = this.props;

    if (!code) {
      return this.state.activeTabIndex === PANES_INDICES.LOCATIONS_DATA ? `Añadir Zona ${name}` : 'Añadir Zona';
    }
    return this.state.activeTabIndex === PANES_INDICES.LOCATIONS_DATA ? `Editar Zona ${name}` : 'Editar Zona';
  }

  renderSaveButton() {
    if (!hasAccessPermission(this.props.permissions, resources.PickingZones, scopes.Edit)) {
      return null;
    }

    const {name, handleSubmit, submitting, valid} = this.props;
    const locationsWithConflict = this.getAssignedLocationsWithConflicts();

    if (valid && locationsWithConflict.length > 0) {
      return (
        <AssignedLocationsConflictModal
          zone={name}
          locations={locationsWithConflict}
          handleSubmit={handleSubmit}
          submitting={submitting}
        />
      );
    }

    return (
      <Button
        primary
        type='submit'
        disabled={submitting}
        onClick={handleSubmit}
      >
        Guardar
      </Button>
    );
  }

  renderPanesContent() {
    const {activeTabIndex} = this.state;
    const tabs = {
      [PANES_INDICES.ZONE_DATA]: <ZoneData { ...this.props } />,
      [PANES_INDICES.LOCATIONS_DATA]: <LocationsData />,
    };
    return tabs[activeTabIndex] || null;
  }

  render() {
    const {submitting} = this.props;
    return (
      <Form
        className='zone-form'
        loading={submitting}
        autoComplete='off'
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>{this.renderFormTitle()}</h2>
              <div className='title-bar-actions'>
                <Button
                  type='button'
                  secondary
                  className='toyota-secondary'
                  onClick={this.onCancelClick}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                {this.renderSaveButton()}
              </div>
            </div>
          </div>

          <Tab
            menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
            panes={panes}
            defaultActiveIndex={this.state.activeTabIndex}
            onTabChange={this.changeTabIndex}
          />
        </Card>

        <Card raised fluid>
          {this.renderPanesContent()}
        </Card>
      </Form>
    );
  }
}

export {ZoneForm};

const form = reduxForm({
  'form': ZONE_FORM.name,
})(ZoneForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.form.zones.loading,
    'name': state.form.zones.values.name,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'goBack': ownProps.goBack,
    'push': ownProps.push,
    'allLocations': state.locations.list,
    'assignedLocations': state.form.zones.values.locations,
  };
};

const {
  fetchZone,
} = Actions;

export default connect(mapStateToProps, {
  fetchZone,
})(form);
